import { createFileRoute } from '@tanstack/react-router';
import {
  getAssistantsQueryOptions,
  getDefaultModelQueryOptions,
} from '../../../features/marketplace/services/queries/assistantApiQueries';

export const Route = createFileRoute('/_app/project')({
  loader: async (ctx) => {
    const assistantDetails = await ctx.context.queryClient.ensureQueryData(
      getAssistantsQueryOptions()
    );
    const defaultModelData = await ctx.context.queryClient.ensureQueryData(
      getDefaultModelQueryOptions()
    );
    return {
      assistantDetails,
      defaultModelData,
      assistantFromUrl: null,
      selectedChaptersFromUrl: [],
    };
  },
});
